import { analyticsDashboard as TYPES } from './../action_types';

const defaultQueryParams = {
  start: moment().subtract(30, 'days').format(),
  finish: moment().format(),
};

const currentQueryParams = function () {
  var queryParams = _.chain($a.decompose_url(location.href)[1])
    .object()
    .pick('start', 'finish')
    .value();

  Object.keys(queryParams).forEach(function (key) {
    queryParams[key] = decodeURIComponent(queryParams[key]);
  });

  const datesValid = _.every(queryParams, function (dateString) {
    return moment(dateString).isValid();
  });
  if (!datesValid) {
    $a.log('Analytics Dashboard: invalid date range');
    return defaultQueryParams;
  }

  return _.chain(queryParams)
    .defaults(defaultQueryParams)
    .map(function (dateStr, key) {
      return [key, new Date(dateStr)];
    })
    .object()
    .value();
};

const initialize = function () {
  return function (dispatch, getState) {
    const newDisplayedDates = currentQueryParams();
    const oldDisplayedDates = getState().AnalyticsDashboard.DisplayedDates;

    if (!_.isEqual(newDisplayedDates, oldDisplayedDates)) {
      dispatch({
        type: TYPES.SET_DISPLAYED_DATES,
        start: newDisplayedDates.start,
        finish: newDisplayedDates.finish,
      });
    }
  };
};

const DisplayedDates = {
  initialize: initialize,
};
export { DisplayedDates };

const initialState = {
  start: null,
  finish: null,
  dayCount: null,
};

const dayCount = function (start, finish) {
  const millisecondCount = moment(finish).diff(moment(start));

  return Math.round(millisecondCount / 1000 / 60 / 60 / 24);
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.SET_DISPLAYED_DATES:
      return Object.assign({}, state, {
        start: action.start,
        finish: action.finish,
        dayCount: dayCount(action.start, action.finish),
      });

    default:
      return state;
  }
};

export { reducer, reducer as default };
